import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=c2dc7cc8&scoped=true"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dc7cc8",
  null
  
)

export default component.exports